import React from "react";

import { IgCheckbox, IgRadio } from "@intelligems/ig-theme";
import { PauseCancelReasonDto } from "@intelligems/ig-types";
import { FormControlLabel, Grid } from "@mui/material";

interface FormCheckboxesProps {
  items: PauseCancelReasonDto[];
  disabled?: boolean;
  onItemClick: (value: string, checked: boolean) => void;
  onSubItemClick: (
    itemValue: string,
    subItemValue: string,
    checked: boolean
  ) => void;
}

export const FormCheckboxes = ({
  items,
  onItemClick,
  onSubItemClick,
  disabled,
}: FormCheckboxesProps) => {
  return (
    <>
      {items.map((item) => {
        const thisItem = items.find((i) => i.value === item.value);

        if (!thisItem) {
          return null;
        }

        return (
          <Grid container item key={item.value} direction={"column"}>
            <Grid item>
              <FormControlLabel
                control={
                  <IgRadio
                    disabled={disabled}
                    size={"small"}
                    onChange={(event) =>
                      onItemClick(item.value, event.target.checked)
                    }
                    checked={thisItem?.checked || false}
                  />
                }
                label={item.text}
              />
            </Grid>
            {thisItem.checked
              ? item.items.map((subItem) => (
                  <Grid item key={subItem.value} sx={{ marginLeft: "32px" }}>
                    <FormControlLabel
                      control={
                        <IgRadio
                          disabled={disabled}
                          size={"small"}
                          checked={subItem.checked || false}
                          onChange={(event) => {
                            onSubItemClick(
                              item.value,
                              subItem.value,
                              event.target.checked
                            );
                          }}
                        />
                      }
                      label={subItem.text}
                    />
                  </Grid>
                ))
              : null}
          </Grid>
        );
      })}
    </>
  );
};
